<template>
    <page>
		<module>
			<module-tab title="自定义单页" @mounted="loadCategory" v-if="false">
				<module-column enable-flex>
					<m-operate>
						<c-button color="sys" icon="add" @click="editHandle('category')">新增栏目</c-button>
					</m-operate>
					
					<c-table ref="category" :paging="false" @row-click="loadArticle">
						<c-table-column
							label="栏目名称"
							name="name"
						></c-table-column>
						
						<c-table-column
							label="状态"
							name="state"
						>
							<template v-slot="{data}">
								{{data.state == 2 ? '启用' : '禁用'}}
							</template>
						</c-table-column>
						
						<c-table-column
							type="sort"
							label="排序"
							@sort="categorySort"
						></c-table-column>
				
						<c-table-column
							type="button"
							label="操作"
							width="110"
						>
							<template v-slot="row">
								<c-table-button power="b_article_edit" @click="editHandle('category', row)">编辑</c-table-button>
								<c-table-button power="b_article_edit" @click="deleteHandle('category', row)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</module-column>
				
				<module-column enable-flex>
					<m-operate>
						<c-button color="sys" icon="add" @click="editHandle('article')">添加页面</c-button>
					</m-operate>
					
					<c-table ref="article" :paging="false">
						<c-table-column
							label="页面标题"
							name="name"
						></c-table-column>
						
						<c-table-column
							label="调用代码"
							name="id"
						>
							<template v-slot="{data}">
								{{`传参：articleId=${data.id}`}}
							</template>
						</c-table-column>
						
						<c-table-column
							type="sort"
							label="排序"
							@sort="articleSort"
						></c-table-column>
				
						<c-table-column
							type="button"
							label="操作"
							width="110"
						>
							<template v-slot="row">
								<c-table-button power="b_article_edit" @click="editHandle('article', row)">编辑</c-table-button>
								<c-table-button power="b_article_edit" @click="deleteHandle('article', row)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</module-column>
			</module-tab>
			
			<module-tab title="固定单页" enable-flex @mounted="loadPage" @activated="fixedPage = true" @deactivated="fixedPage = false">
				<c-table ref="page" :paging="false">
					<c-table-column
						label="页面标题"
						name="name"
					></c-table-column>
					
					<c-table-column
						label="调用代码"
						name="id"
					>
						<template v-slot="{data}">
							{{`传参：articleId=${data.id}`}}
						</template>
					</c-table-column>
					
					<c-table-column
						type="sort"
						label="排序"
						@sort="articleSort"
					></c-table-column>
			
					<c-table-column
						type="button"
						label="操作"
						width="110"
					>
						<template v-slot="row">
							<c-table-button power="b_article_edit" @click="editHandle('article', row)">编辑</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</module-tab>
		</module>
		
		<c-dialog ref="categoryEdit" :title="editState ? '编辑栏目' : '新增栏目'" width="600" @resolve="editCategoryHandle">
			<c-form ref="categoryForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="input" label="栏目名称" name="name" required></c-form-item>
			</c-form>
		</c-dialog>
		
		<c-dialog ref="articleEdit" :title="editState ? '编辑页面' : '添加页面'" width="800" @resolve="editArticleHandle">
			<c-form ref="articleForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="input" label="页面标题" name="name" required></c-form-item>
				<c-form-item v-show="!fixedPage" type="select" label="所属栏目" name="category_id" :options="categoryList" required></c-form-item>
				<c-form-item type="editor" label="内容" name="content"></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_article',
		
		data() {
			return {
				editState: false,
				fixedPage: false,
				categoryList: []
			}
		},
		
		methods: {
			loadCategory() {
				this.$refs.category.load({
					url: '/article/category/list'
				});
			},
			
			loadPage() {
				this.$refs.page.load({
					url: '/article/list',
					data: {
						category_id: 0
					}
				});
			},
			
			loadArticle(row) {
				this._category = row;
				this.$refs.article.load({
					url: '/article/list',
					data: {
						category_id: row.data.id
					}
				});
			},
			
			editHandle(type, row) {
				this.editState = !!row;
				if (row) {
                    this.$refs[`${type}Form`].clear();
                    this.request({
                        url: '/article/detail',
                        data: {
                            id: row.data.id
                        },
                        loading: true,
                        success: data => {
                            this.$refs[`${type}Form`].set(data);
                        }
                    });

				} else {
					this.$refs[`${type}Form`].clear();
				}
				
				//自定义单页此处隐藏 2023-11-30 for wangpeng
				// if (type == 'article') {
				// 	this.categoryList = Array.from(this.$refs.category.getRow(), item => {
				// 		return {
				// 			name: item.data.name,
				// 			value: item.data.id
				// 		}
				// 	});
					
				// 	if (this._category && !this.editState) {
				// 		this.$nextTick(() => {
				// 			this.$refs.articleForm.set({
				// 				category_id: this._category.data.id
				// 			});
				// 		});
				// 	}
				// }
				
				this.$refs[`${type}Edit`].open();
			},
			
			editCategoryHandle(stop) {
				stop();
				this.$refs.categoryForm.submit({
					url: '/article/category/edit',
					rule: {
						name: '请填写栏目标题'
					},
					success: () => {
						this.$refs.category.update();
						this.$refs.categoryEdit.close();
					}
				});
			},
			
			editArticleHandle(stop) {
				stop();
				this.$refs.articleForm.submit({
					url: '/article/edit',
					rule: {
						name: '请填写页面标题',
						category_id: [{
							type: 'empty',
							word: '请选择所属栏目',
							skip: () => {
								return this.fixedPage
							}
						}]
					},
					success: () => {
						if (this.fixedPage) {
							this.$refs.page.update();
						} else {
							this.$refs.article.update();	
						}
						this.$refs.articleEdit.close();
					}
				});
			},
			
			categorySort(row, type, next) {
				this.sortHandle('/article/category/sort', row, type, next);
			},
			
			articleSort(row, type, next) {
				this.sortHandle('/article/sort', row, type, next);
			},
			
			sortHandle(url, row, type, next) {
				this.request({
					url: url,
					data: {
						id1: row.data.id,
						id2: type == 'up' ? row.prev().data.id : row.next().data.id,
					},
					loading: true,
					success: data => {
						next();
					}
				});
			},
			
			deleteHandle(type, row) {
				this.$confirm({
					text: `确定要删除此${type == 'article' ? '页面' : '栏目'}吗？`,
					resolve: () => {
						this.request({
							url: type == 'article' ? '/article/remove' : '/article/category/remove',
							data: {
								id: row.data.id
							},
							loading: true,
							success: data => {
								this.$message({
									text: '删除成功'
								});
								row.remove();
							}
						});
					}
				});
			}
		}
	}
</script>